import type { SubmissionStatus } from "../types/MainType.type";

interface StatusBadgeProps {
  status: SubmissionStatus;
  isOriginUser?: boolean;
}

// Status Badge Helper Component
export const StatusBadge = ({ status, isOriginUser = false }: StatusBadgeProps) => {
  switch (status) {
    case 'DRAFT':
      return (
        <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600 ring-1 ring-inset ring-slate-500/10">
          မူကြမ်း
        </span>
      );

    case 'APPROVED':
      return (
        <span className="inline-flex items-center rounded-md bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/20">
          ကိုယ်တိုင်အတည်ပြုပြီး
        </span>
      );

    case 'SUBMITTED':
      return isOriginUser ? (
        <span className="inline-flex items-center rounded-md bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700 ring-1 ring-inset ring-amber-600/20">
          တင်ပြပြီး
        </span>
      ) : (
        <span className="inline-flex items-center rounded-md bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/20">
          လက်ခံရရှိသည်
        </span>
      );

    case 'UNDER_REVIEW':
      return isOriginUser ? (
        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-[11px] font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
          ကြည့်ရှုထားသည်
        </span>
      ) : (
        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-[11px] font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
          ကြည့်ရှုထားသည်
        </span>
      );

    case 'ATTACHED':
      return (
        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-[11px] font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
          ညွှန်ကြားထားသည်
        </span>
      );

    default:
      return null;
  }
};